import { Box, Paper, Skeleton, Typography } from '@mui/material';
import Theme from '../../Themes/main.theme';
import ConditionalWrapper from '../ConditionalWrapper/ConditionalWrapper';
import { InfoBoxType } from './types';

const InfoBoxes = ({infoDetails, title, direction, isLoading}: InfoBoxType) => {

  const directionProps = {
    ...(direction === 'column' 
      ? {
        flexDirection: 'column',
        alignItems: 'center',
      }
      : {
        gap: 2,
      }
    )
  };

  const loader = (children: any) => {
    return (<>
      <Box display='flex' justifyContent='center'>
        <Skeleton variant='text'>{children}</Skeleton>
      </Box>
    </>);
  }; 
  

  return (
    <>
      {title
        ? <Box display='flex' flexDirection='row'
          justifyContent='center'>
          <Box sx={
            { backgroundColor: Theme.labelColor?.background, py: 1, px: 2, mb: 4, borderRadius: 1}}>
            <Typography variant='h3' color={Theme.labelColor?.main}>
              {title}
            </Typography>
          </Box>
        </Box> 
        : null
      }
      <Box sx={{ display: 'flex', ...directionProps }}>
        {infoDetails.map((info) => {
          return <Paper key={String(info.label)} sx={{ padding: 2, mb: 2, width: '350px', height: '80px' }}>
            <ConditionalWrapper condition={isLoading} 
              wrapper={(children) => loader(children)}>
              <Typography mb={1} variant='h4'
                color={Theme.labelColor?.main}
                sx={{ display: 'flex', justifyContent: 'center'}}>
                {info.label}
              </Typography>
            </ConditionalWrapper>
            <ConditionalWrapper condition={isLoading} 
              wrapper={(children) => loader(children)}>
              <Typography variant='h3' sx={{ display: 'flex', justifyContent: 'center'}}>
                {info.count}
              </Typography>
            </ConditionalWrapper>
          </Paper>;
        })}
      </Box>
    </>
  );
};

export default InfoBoxes;